import Service from "../service";
//const url = 'pregnant/form3'
const ReportSummary ={
    show(model){
        return Service.post(`get-report-summary`,model);
    },
}
export default ReportSummary